module.exports = __webpack_public_path__ + "img/TEXT_WITH_IMAGE.03d684fd.svg";